import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Icon } from "../icon/icon.es.js";
import { TabAddButtonImpl } from "./tab-add-button.styles.es.js";
const propTypes = {
  onClick: PropTypes.func.isRequired
};
const TabAddButton = ({ onClick }) => /* @__PURE__ */ jsx(TabAddButtonImpl, { onClick, children: /* @__PURE__ */ jsx(Icon, { type: "plus" }) });
TabAddButton.propTypes = propTypes;
export {
  TabAddButton
};
